export default __webpack_public_path__ + "static/slide0-5d7d3b2f3cf3d2f9b4e08dbfdfe6710f.jpg";